import React from 'react';
import Select from 'react-select';

interface Guest {
  id: number;
  firstName: string;
  lastName?: string;
}

interface GuestSelectorProps {
  guests: Guest[];
  selectedGuestId: string;
  onSelect: (guestId: string) => void;
  loading: boolean;
  error?: string;
}

interface OptionType {
  value: string;
  label: string;
}

const GuestSelector: React.FC<GuestSelectorProps> = ({
  guests,
  selectedGuestId,
  onSelect,
  loading,
  error,
}) => {
  const options: OptionType[] = guests.map((guest) => ({
    value: guest.id.toString(),
    label: `${guest.firstName} ${guest.lastName || ''}`.trim(),
  }));

  const selectedOption = options.find((opt) => opt.value === selectedGuestId) || null;

  const handleChange = (option: OptionType | null) => {
    if (!option) {
      // Explicitly handle clear
      onSelect('');
    } else {
      onSelect(option.value);
    }
  };

  const customStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: '48px',
      borderRadius: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(10px)',
      boxShadow: 'none',
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
    }),
    menuList: (base: any) => ({
      ...base,
      padding: '4px',
      maxHeight: '300px',
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected
        ? 'rgba(88, 129, 87, 0.9)'
        : state.isFocused
        ? 'rgba(88, 129, 87, 0.1)'
        : 'transparent',
      color: state.isSelected ? '#fff' : '#333',
      cursor: 'pointer',
      borderRadius: '4px',
      marginBottom: '2px',
      '&:active': {
        backgroundColor: 'rgba(88, 129, 87, 0.2)',
      },
    }),
  };

  return (
    <>
      <div className="card-header">
        <h2>Sélectionnez votre nom</h2>
        <p className="card-subtitle">Choisissez votre nom dans la liste pour accéder au formulaire RSVP.</p>
      </div>

      {error && <div className="error-banner">{error}</div>}

      {loading ? (
        <p className="info-text">Chargement de la liste des invités...</p>
      ) : (
        <>
          <div className="form-group-modern">
            <label htmlFor="guest-select">Votre nom</label>
            <Select
              inputId="guest-select"
              classNamePrefix="guest-select"
              value={selectedOption}
              onChange={handleChange}
              options={options}
              styles={customStyles}
              placeholder="Recherchez et sélectionnez votre nom..."
              noOptionsMessage={() => 'Aucun invité trouvé'}
              isSearchable={true}
              isClearable={true}
            />
          </div>
        </>
      )}
    </>
  );
};

export default GuestSelector;
